import {
  type StravaActivityZone,
  StravaActivityZonesTypeSection,
} from "./StravaActivityZonesTypeSection";

interface StravaActivityZonesProps {
  zones: StravaActivityZone[];
  zonesAvailable: boolean;
}

export function StravaActivityZones(props: StravaActivityZonesProps) {
  if (!props.zonesAvailable) {
    return (
      <p className="text-xs text-muted-foreground">
        Heart rate zones require Strava Summit subscription.
      </p>
    );
  }

  if (props.zones.length === 0) {
    return null;
  }

  return (
    <div className="space-y-4">
      <h4 className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
        Zones
      </h4>
      {props.zones.map((zone) => {
        return <StravaActivityZonesTypeSection key={zone.id} zone={zone} />;
      })}
    </div>
  );
}
